import store from "@/store";
import { getFromLocalStorage } from "@/utils/localstorage";

export default async function fetchUserData({ next }) {
  store.commit("auth/clearErrors");
  const token = getFromLocalStorage("authtoken", null);

  if (!token || store.getters["user/getCurrentUser"]) {
    return next();
  }

  await store
    .dispatch("user/fetchCurrentUser")
    .then(() => {
      store.commit("loader/userLoaded");

      return next();
    })
    .catch(({ response }) => {
      store.commit("user/setCurrentUser", null);
      localStorage.removeItem("authtoken");

      if (response && response.status === 403) {
        return next({
          name: "Blocked",
        });
      }

      return next();
    });
}
